import CapsApiService from '@/services/capsapi/capsApi.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {

    // ----------------- Table MapSavedMap
    async getGpoContractDetailDataForApiCall({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await CapsApiService.getGpoContractDetailDataForApiCall(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },

    // ----------------- End Table MapSavedMap


}

const mutations = {
}

export const capsApi = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}